import { createAction } from "@reduxjs/toolkit";

export const initAction = createAction('initAction');
export const isAuthorized = createAction('isAuthorized');


